import React from "react";
import { Button, Icon, Text } from "@chakra-ui/react";
import { FaFileDownload } from "react-icons/fa";

const DownloadCV = (): JSX.Element => {
  const download = (): void => {
    const url = "/Manish_Parui_ CV.pdf";
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Manish_Parui_ CV.pdf"); // optional, sets file name
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <Button gap={3} variant={"neon"} onClick={download}>
      <Icon as={FaFileDownload} />
      <Text>Download CV</Text>
    </Button>
  );
};

export default DownloadCV;
